<template>
	<section class="p-r p-l p-x-n">
    	<router-view></router-view>		
	</section>
	
</template>

<script>
export default {  
}
</script>
<style scoped>
	@media only screen and (max-width: 767px) {
		.p-x-n {
			padding: 0px;
		}

	}
</style>
